export default __webpack_public_path__ + "static/media/explore-desktop-4.3d22cb93.png";